import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { refreshProjectMediaTagsData } from './refreshProjectMediaTagsData.thunk';

// The tagger lands 10–15 s after a photo is filed; the second read catches a
// cold start or a slow HEIC conversion.
const REFRESH_DELAYS_MS = [30 * 1000, 90 * 1000];

const timersByProjectId = {};

/**
 * Reads the project's tags again once the AI tagger has had time to tag a photo
 * that was just filed — see `refreshProjectMediaTagsData` for why.
 */
export const scheduleProjectMediaTagsRefresh =
  (projectId) => (dispatch, getState) => {
    if (!projectId) return;

    // A batch files its photos one after another. Restarting the wait on each
    // makes the whole batch cost two reads rather than two per photo.
    (timersByProjectId[projectId] || []).forEach(clearTimeout);

    timersByProjectId[projectId] = REFRESH_DELAYS_MS.map((delay) =>
      setTimeout(() => {
        // Left the project: nothing shows its tags, and going back loads them.
        if (selectSelectedProjectId(getState()) !== projectId) return;

        dispatch(refreshProjectMediaTagsData({ force: true }));
      }, delay)
    );
  };
